import { Language } from '@quizdb/common';
import { MaterialPrepErrorCode } from '../extraction/extractionTypes';

/** The photo MIME types a job can use (PHO-D3). */
export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

/**
 * The file picker's `accept` for {@link PHOTO_TYPES}. Extensions, not MIME types: Windows
 * expands `image/jpeg` into every extension registered for it, `*.jfif` and `*.pjp` among them.
 */
export const PHOTO_ACCEPT = '.jpg,.jpeg,.png,.webp';

/** The clockwise turn the admin added, on top of EXIF. */
export type PhotoRotation = 0 | 90 | 180 | 270;

/**
 * One photographed page, as the admin added it. `id` is a client-side key for React, not a
 * hash. `sha256` is the file's hash once computed. `text` is the OCR text once `status` is
 * `'ready'`. `error` is set once `status` is `'failed'`.
 */
export interface Photo {
  id: string;
  file: File;
  rotation: PhotoRotation;
  sha256?: string;
  status: 'reading' | 'ready' | 'failed';
  text?: string;
  error?: MaterialPrepErrorCode;
}

/** A set of photographed pages, in the admin's order: photo N is `photos[N - 1]` (QZ-D91). */
export interface PhotoSet {
  photos: Photo[];
}

/** Props for the section of the new-job page that collects a `PhotoSet`. */
export interface PhotoMaterialSectionProps {
  value: PhotoSet;
  onChange(set: PhotoSet): void;
  pageLanguage: Language;
  onPageLanguageChange(language: Language): void;
  error?: string;
  disabled?: boolean;
}
